package pl.mothdigital.neuronowi.pages.therapies.integracjaSensoryczna

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.icons.fa.*
import pl.mothdigital.neuronowi.common.model.*
import pl.mothdigital.neuronowi.components.layouts.*

@Page
@Composable
fun TherapySensoryIntegrationPage() {
    TherapyPageLayout(
        content = TherapyPageContent(
            title = "Integracja sensoryczna",
            icon = { FaPuzzlePiece() },
            description = "Diagnoza i terapia zaburzeń przetwarzania sensorycznego, wspierająca prawidłowy rozwój dziecka.",
            sections = listOf(
                TherapySection(
                    title = "Czym jest integracja sensoryczna?",
                    content = """
                        Integracja sensoryczna (SI) to neurologiczny proces organizowania informacji sensorycznych
                        z własnego ciała i środowiska, który pozwala na skuteczne funkcjonowanie w codziennym życiu.
                        Terapia integracji sensorycznej pomaga dzieciom, które mają trudności z przetwarzaniem
                        bodźców zmysłowych pochodzących z różnych systemów czuciowych.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Dla kogo jest terapia integracji sensorycznej?",
                    content = """
                        Terapia SI jest szczególnie pomocna dla dzieci z:

                        • Zaburzeniami przetwarzania sensorycznego
                        • Nadwrażliwością lub podwrażliwością na bodźce
                        • Zaburzeniami ze spektrum autyzmu
                        • ADHD (zespół nadpobudliwości psychoruchowej)
                        • Opóźnieniami rozwoju psychoruchowego
                        • Trudnościami w koncentracji i uwadze
                        • Problemami z koordynacją i równowagą
                        • Trudnościami w nauce i funkcjonowaniu społecznym
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jakie korzyści przynosi terapia SI?",
                    content = """
                        Prawidłowo prowadzona terapia integracji sensorycznej może przynieść wiele korzyści:

                        • Poprawę przetwarzania informacji sensorycznych
                        • Lepszą regulację poziomu pobudzenia
                        • Zwiększenie tolerancji na różne bodźce
                        • Poprawę koncentracji i uwagi
                        • Lepszą koordynację i świadomość ciała
                        • Wzrost pewności siebie w działaniach ruchowych
                        • Poprawę funkcjonowania w codziennych sytuacjach
                        • Lepsze radzenie sobie ze stresem
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Jak przebiega terapia?",
                    content = """
                        Proces terapii integracji sensorycznej w Centrum Terapii NeuroNowi obejmuje:

                        1. Szczegółową diagnozę SI - ocenę funkcjonowania wszystkich systemów sensorycznych
                           oraz ich integracji.

                        2. Opracowanie indywidualnego programu terapeutycznego dostosowanego do profilu
                           sensorycznego dziecka.

                        3. Regularne sesje terapeutyczne w specjalnie wyposażonej sali SI z wykorzystaniem
                           profesjonalnego sprzętu (huśtawki, trampoliny, materace, piłki terapeutyczne).

                        4. Edukację rodziców/opiekunów dotyczącą wsparcia dziecka w domu i szkole.

                        5. Współpracę z innymi specjalistami (logopedami, fizjoterapeutami, psychologami)
                           w przypadku terapii kompleksowej.
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasze metody",
                    content = """
                        W terapii integracji sensorycznej stosujemy różnorodne techniki i podejścia:

                        • Aktywności na huśtawkach i urządzeniach zawieszonych
                        • Ćwiczenia proprioceptywne (czucie głębokie)
                        • Stymulację dotykową różnymi fakturami
                        • Aktywności vestibularne (równoważne)
                        • Ćwiczenia koordynacyjne i planowania ruchowego
                        • Techniki regulacji sensorycznej
                        • Aktywności z wykorzystaniem ciężaru i oporów
                        • Ćwiczenia integrujące różne systemy czuciowe
                    """.trimIndent()
                ),
                TherapySection(
                    title = "Nasi specjaliści",
                    content = """
                        Terapię integracji sensorycznej w naszym centrum prowadzą certyfikowani terapeuci SI
                        z wieloletnim doświadczeniem w pracy z dziećmi. Nasi specjaliści posiadają odpowiednie
                        kwalifikacje i regularnie uczestniczą w szkoleniach, aby zapewnić pacjentom dostęp do
                        najnowszych i najbardziej skutecznych metod terapeutycznych w obszarze integracji sensorycznej.
                    """.trimIndent()
                )
            )
        )
    )
}
